import React from 'react';
import { FreeTextKey } from '../../../../types/FreeText';
import { DH } from '../../../../utils/DataHook';
import { t } from '../../../../utils/i18n';
import { AddPaymentMethodButton } from '../../../AddPaymentMethodButton';
import s from '../../styles.scss';
import { IEmptyViewConnectedProps } from './view.connect';

export const EmptyView: React.FC<IEmptyViewConnectedProps> = (props) => (
  <section className={s.emptyView} data-hook={DH.EmptyView.Container}>
    <div data-hook={DH.EmptyView.Title} role="heading" tabIndex={0}>
      {props.freeText[FreeTextKey.NoItemsMessage] || t('wallet.no-items-message')}
    </div>
    <div data-hook={DH.EmptyView.Subtitle}>{props.freeText[FreeTextKey.NoItemsInfo] || t('wallet.no-items-info')}</div>
    {props.canAddPaymentMethod && (
      <div className={s.addPaymentMethodButtonWrapper}>
        <AddPaymentMethodButton />
      </div>
    )}
  </section>
);
EmptyView.displayName = 'EmptyView';
